import { render, staticRenderFns } from "./kindChooseViewktypevipNew.vue?vue&type=template&id=b9b6912c&scoped=true"
import script from "./kindChooseViewktypevipNew.vue?vue&type=script&lang=js"
export * from "./kindChooseViewktypevipNew.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewktypevipNew.vue?vue&type=style&index=0&id=b9b6912c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b6912c",
  null
  
)

export default component.exports